__turbopack_context__.v({
  "field": "TextArea-module__BJ0JkG__field",
  "fieldRounded": "TextArea-module__BJ0JkG__fieldRounded",
  "helpText": "TextArea-module__BJ0JkG__helpText",
  "wrapper": "TextArea-module__BJ0JkG__wrapper",
});
